<ds-loader id="loader" />
<router-outlet />
